/* ユーザー関連 データベース定義
*/
export class DbUser {
    // 申込番号
    public applicationNumber: number;
    // 園（名称）
    public ainderGarten: string;
    // 園（都道府県）
    public prefectures: string;
    // 園（市区町村）
    public municipality: string;
    // 氏名（漢字）
    public name: string;
    // 氏名（ふりがな）
    public nameFurigana: string;
    // 生年月日
    public birthday: string;
    // メールアドレス
    public email: string;
    // firebase user uid
    public uid: string;

    // 講義・分科会等N（{名称}）：申込
    public lecturesSubcommittees: string[];

    // 講義・分科会等N（{名称}）：申込 した 一覧
    public applicationLecturesSubcommittees: string[];

    // 役割 0: student 1: admin
    public role: number;

    public static ROLE = {
        "student": 0,
        "admin": 1,
    };

    // コンストラクタ
    constructor(){
        this.applicationNumber = 0;
        this.ainderGarten = "";
        this.prefectures = "";
        this.municipality = "";
        this.name = "";
        this.nameFurigana = "";
        this.birthday = "";
        this.email = "";
        this.uid = "";
        this.role = 0;
        this.lecturesSubcommittees = [];
        this.applicationLecturesSubcommittees = [];
    }

    // コンバーター
    public static Converter = {
        toFirestore: function(src: any) {
            return {
                applicationNumber: parseInt(src.applicationNumber),
                ainderGarten: src.ainderGarten,
                prefectures: src.prefectures,
                municipality: src.municipality,
                name: src.name,
                nameFurigana: src.nameFurigana,
                birthday: src.birthday,
                email: src.email,
                uid: src.uid,
                role: src.role,
                lecturesSubcommittees: src.lecturesSubcommittees,
                applicationLecturesSubcommittees: src.applicationLecturesSubcommittees
            }
        },
        fromFirestore: function(snapshot: any, options: any){
            const data = snapshot.data(options);
            const dst = new DbUser();
            dst.applicationNumber = parseInt(data.applicationNumber);
            dst.ainderGarten =  data.ainderGarten
            dst.prefectures = data.prefectures;
            dst.municipality = data.municipality;
            dst.name = data.name;
            dst.nameFurigana = data.nameFurigana;
            dst.birthday = data.birthday;
            dst.email = data.email;
            dst.uid = data.uid;
            dst.role = data.role;
            dst.lecturesSubcommittees = data.lecturesSubcommittees;
            dst.applicationLecturesSubcommittees = data.applicationLecturesSubcommittees;
            return dst;
        }
    }
}

// 受講者 > 受講ステータス
export class DbUserCourseManagement {
    // 受講ID
    public id: string;
    // 受講状況
    public status: string;
    //開始日時
    public from: Date;
    //終了日時
    public to: Date | null;

    public static STATUS = {
        "NotAttended": "notattended",
        "During": "during",
        "Done": "done",
    };

    // コンストラクタ
    constructor(){
        this.id = "";
        this.status = DbUserCourseManagement.STATUS.NotAttended;
        this.from = (new Date());
        this.to = null;
    }

    // コンバーター
    public static Converter = {
        toFirestore: function(src: any) {
            return {
                id: src.id,
                status: src.status,
                from: src.from,
                to: src.to
            }
        },
        fromFirestore: function(snapshot: any, options: any){
            const data = snapshot.data(options);
            const dst = new DbUserCourseManagement();
            dst.id = data.id;
            dst.status =  data.status;
            dst.from = data.from;
            dst.to = data.to;
            return dst;
        }
    }
}

// 受講者 > 講習 受講ステータス
export class DbUserCourseManagementDetail {
    // 受講詳細ID
    public id: string;
    // 受講状況
    public status: string;
    //更新日時
    public updateDate: Date;

    public static STATUS = {
        "NotAttended": "notattended",
        "During": "during",
        "Done": "done",
    };

    // コンストラクタ
    constructor(){
        this.id = "";
        this.status = DbUserCourseManagementDetail.STATUS.NotAttended;
        this.updateDate = (new Date());
    }

    // コンバーター
    public static Converter = {
        toFirestore: function(src: any) {
            return {
                id: src.id,
                status: src.status,
                updateDate: src.updateDate
            }
        },
        fromFirestore: function(snapshot: any, options: any){
            const data = snapshot.data(options);
            const dst = new DbUserCourseManagementDetail();
            dst.id = data.id;
            dst.status =  data.status;
            dst.updateDate = data.updateDate;
            return dst;
        }
    }
}